import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatOptionalId, resolveDepositCurrencyAmount } from './depositConstants';

export default function DepositUpdateAmountModal({ open, row, onClose, onSaved }) {
  const [amount, setAmount] = useState('');
  const [remark, setRemark] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && row) {
      const current = resolveDepositCurrencyAmount(row);
      setAmount(current != null ? String(current) : '');
      setRemark(row.remark || '');
      setError('');
    }
  }, [open, row?.id]);

  if (!open || !row) {
    return null;
  }

  function resetForm() {
    const current = resolveDepositCurrencyAmount(row);
    setAmount(current != null ? String(current) : '');
    setRemark(row.remark || '');
    setError('');
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const parsed = Number(amount);
    if (!amount || Number.isNaN(parsed) || parsed <= 0) {
      setError('請輸入有效的入金幣種數量');
      return;
    }

    setSubmitting(true);
    setError('');
    try {
      await adminApi.depositOfflineUpdateAmount({
        id: row.id,
        updateCurrencyAmount: parsed,
        remark: remark?.trim() || undefined,
      });
      onSaved?.();
      onClose();
    } catch (err) {
      setError(err.message || '更新失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>更改入金幣種數量 [{formatOptionalId(row.id)}]</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="form-field">
              <span className="form-label">用戶ID</span>
              <p className="form-static">{formatOptionalId(row.memberId)}</p>
            </div>
            <div className="form-field">
              <label htmlFor="depositUpdateAmount">
                <span className="required-mark">*</span> 入金幣種數量
              </label>
              <input
                id="depositUpdateAmount"
                type="number"
                min="0"
                step="any"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="form-field">
              <span className="form-label">入金幣種</span>
              <p className="form-static">{row.currencyName || '—'}</p>
            </div>
            <div className="form-field">
              <label htmlFor="depositUpdateAmountRemark">備註</label>
              <input
                id="depositUpdateAmountRemark"
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>
            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={resetForm}
              disabled={submitting}
            >
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
